/**
 *
 * Alerts
 *
 */

import React from 'react';

import { AggregateAlertDetails } from 'containers/Findings/AlertDrawer/AggregateAlertDetails';
import { IndividualAlertDetails } from 'containers/Findings/AlertDrawer/IndividualAlertDetails';
import { useSearchParams } from 'hooks/useSearchParams';

export const AlertDetails = () => {
  const params = useSearchParams<{ aggregated: string }>();

  return !!params?.aggregated ? (
    <AggregateAlertDetails />
  ) : (
    <IndividualAlertDetails />
  );
};
